var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Observer } from 'mobx-react-lite';
import React from 'react';
import joinClassName from '../../utils/className.utils';
import { useProps, useStore } from '../../utils/mobx.utils';
import ContactTypeSelector from '../ContactTypeSelector/ContactTypeSelector';
import { useFormContext } from '../FormForm/Form.context';
function FormContactTypeSelector(props) {
    var context = useFormContext();
    var form = context.form;
    var p = useProps(props);
    var s = useStore(function () { return ({
        get form() {
            var _a;
            return (_a = p.form) !== null && _a !== void 0 ? _a : form;
        },
    }); });
    return React.createElement(Observer, { children: function () {
            var _a;
            return (React.createElement(ContactTypeSelector, __assign({}, p, { className: joinClassName('FormContactTypeSelector', p.className), form: s.form.fields[p.field], field: "value", name: (_a = p.name) !== null && _a !== void 0 ? _a : p.field, disabled: p.disabled || context.disabled })));
        } });
}
export default FormContactTypeSelector;
